import { useTheme } from 'hooks/theme';
import { FC } from 'react';
import { ScSpinner, ScSpinnerProps } from './styled';

export const Spinner: FC<ScSpinnerProps> = (props) => {
  const { preloaderSpinnerAnimation: PreloaderSpinnerAnimation } = useTheme();

  return (
    <ScSpinner {...props}>
      <PreloaderSpinnerAnimation />
    </ScSpinner>
  );
};
